import { supabase } from './supabase';

// Drops this browser's copy of the Supabase session without asking the server.
//
// signOut({ scope: 'local' }) still sends POST /logout first, and auth-js
// returns early when that request fails (offline, captive wifi, a 5xx): the
// token stays in storage and no SIGNED_OUT fires. The app then showed the
// login page while the next person at the browser opened the dashboard as the
// coach who had just "signed out" (2026-10-07). Ending a session on this
// browser never needs the server; revoking the refresh token is a bonus.
export async function endLocalSession() {
  const auth = supabase.auth;
  try {
    // auth-js's own cleanup, which also tells this tab's listeners and the
    // other tabs SIGNED_OUT. Not public API, hence the guard.
    if (typeof auth?._removeSession === 'function') await auth._removeSession();
  } catch (error) {
    console.warn('Could not clear the session through auth-js:', error?.message || error);
  }
  // The same keys by hand, in case the method above is missing or failed.
  const key = auth?.storageKey;
  if (!key) return;
  try {
    ['', '-code-verifier', '-user'].forEach((suffix) => window.localStorage.removeItem(`${key}${suffix}`));
  } catch { /* storage unavailable */ }
}
